<template>
  <div>
    <Button class="mobile-menu__catalog-trigger" @click.native="$emit('openCatalog')">
      <svg width="19"
           height="18"
           viewBox="0 0 19 18"
           fill="none"
           xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_5032_356)">
          <path fill-rule="evenodd"
                clip-rule="evenodd"
                d="M4.22414 5.89655C5.42393 5.89655 6.39655 4.92393 6.39655 3.72414C6.39655 2.52435 5.42393 1.55172 4.22414 1.55172C3.02435 1.55172 2.05172 2.52435 2.05172 3.72414C2.05172 4.92393 3.02435 5.89655 4.22414 5.89655ZM4.22414 7.44828C6.28092 7.44828 7.94828 5.78092 7.94828 3.72414C7.94828 1.66735 6.28092 0 4.22414 0C2.16735 0 0.5 1.66735 0.5 3.72414C0.5 5.78092 2.16735 7.44828 4.22414 7.44828Z"
                fill="white"/>
          <path fill-rule="evenodd"
                clip-rule="evenodd"
                d="M14.7749 5.89655C15.9747 5.89655 16.9473 4.92393 16.9473 3.72414C16.9473 2.52435 15.9747 1.55172 14.7749 1.55172C13.5751 1.55172 12.6025 2.52435 12.6025 3.72414C12.6025 4.92393 13.5751 5.89655 14.7749 5.89655ZM14.7749 7.44828C16.8317 7.44828 18.4991 5.78092 18.4991 3.72414C18.4991 1.66735 16.8317 0 14.7749 0C12.7181 0 11.0508 1.66735 11.0508 3.72414C11.0508 5.78092 12.7181 7.44828 14.7749 7.44828Z"
                fill="white"/>
          <path fill-rule="evenodd"
                clip-rule="evenodd"
                d="M14.7749 16.4483C15.9747 16.4483 16.9473 15.4757 16.9473 14.2759C16.9473 13.0761 15.9747 12.1035 14.7749 12.1035C13.5751 12.1035 12.6025 13.0761 12.6025 14.2759C12.6025 15.4757 13.5751 16.4483 14.7749 16.4483ZM14.7749 18C16.8317 18 18.4991 16.3327 18.4991 14.2759C18.4991 12.2191 16.8317 10.5518 14.7749 10.5518C12.7181 10.5518 11.0508 12.2191 11.0508 14.2759C11.0508 16.3327 12.7181 18 14.7749 18Z"
                fill="white"/>
          <path fill-rule="evenodd"
                clip-rule="evenodd"
                d="M4.22414 16.4483C5.42393 16.4483 6.39655 15.4757 6.39655 14.2759C6.39655 13.0761 5.42393 12.1035 4.22414 12.1035C3.02435 12.1035 2.05172 13.0761 2.05172 14.2759C2.05172 15.4757 3.02435 16.4483 4.22414 16.4483ZM4.22414 18C6.28092 18 7.94828 16.3327 7.94828 14.2759C7.94828 12.2191 6.28092 10.5518 4.22414 10.5518C2.16735 10.5518 0.5 12.2191 0.5 14.2759C0.5 16.3327 2.16735 18 4.22414 18Z"
                fill="white"/>
        </g>
        <defs>
          <clipPath id="clip0_5032_356">
            <rect width="18"
                  height="18"
                  fill="white"
                  transform="translate(0.5)"/>
          </clipPath>
        </defs>
      </svg>
      <span>{{ $t('up.menu.catalog') }}</span>
    </Button>
  </div>
</template>

<script>
import Button from '@/components/inputs/Button.vue'

export default {
  name: 'MobileMenuCatalog',
  components: { Button }
}
</script>

<style lang="sass" scoped="">
.mobile-menu
  &__catalog-trigger
    max-width: 320px
    width: 100%
    display: flex
    align-items: center
    text-transform: uppercase
    color: #fff
    justify-content: center
    font-size: 14px
    font-weight: 500
    padding: 13px
    border-radius: 3px
    background-color: #FF2F00
    border-color: #FF2F00
    svg
      margin-right: 15px
</style>
